import c from "@emotion/styled/base";
function e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const n = /* @__PURE__ */ c("tr", process.env.NODE_ENV === "production" ? {
  target: "e105aojh0"
} : {
  target: "e105aojh0",
  label: "HeaderRowContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1ayvr8f",
  styles: "&>:nth-of-type(1){padding:8px 12px 8px 24px;}&>:last-child{padding:8px 24px 8px 12px;}"
} : {
  name: "1ayvr8f",
  styles: "&>:nth-of-type(1){padding:8px 12px 8px 24px;}&>:last-child{padding:8px 24px 8px 12px;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvVGFibGUvc3ViQ29tcG9uZW50cy9IZWFkZXJSb3cvSGVhZGVyUm93LnN0eWxlZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFMkMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvcGFydG9vLXVpL3BhcnRvby11aS9wYWNrYWdlcy91aS9zcmMvY29tcG9uZW50cy9UYWJsZS9zdWJDb21wb25lbnRzL0hlYWRlclJvdy9IZWFkZXJSb3cuc3R5bGVkLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5leHBvcnQgY29uc3QgSGVhZGVyUm93Q29udGFpbmVyID0gc3R5bGVkLnRyYFxuICAgICYgPiA6bnRoLW9mLXR5cGUoMSkge1xuICAgICAgICBwYWRkaW5nOiA4cHggMTJweCA4cHggMjRweDtcbiAgICB9XG4gICAgJiA+IDpsYXN0LWNoaWxkIHtcbiAgICAgICAgcGFkZGluZzogOHB4IDI0cHggOHB4IDEycHg7XG4gICAgfVxuYDtcbiJdfQ== */",
  toString: e
});
export {
  n as HeaderRowContainer
};
